import { render, staticRenderFns } from "./HistoryDentist.vue?vue&type=template&id=01006082&scoped=true&"
import script from "./HistoryDentist.vue?vue&type=script&lang=js&"
export * from "./HistoryDentist.vue?vue&type=script&lang=js&"
import style0 from "./HistoryDentist.vue?vue&type=style&index=0&id=01006082&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01006082",
  null
  
)

export default component.exports